import React from 'react';

import {TextInput} from 'components/forms/Inputs';
import {SubEventType, EventType} from 'types/App';
import {Button} from '@mui/material';
import ViewMap from '../ViewMap';
import GeoReferenceMap from '../GeoreferenceMap';
import {useWatch} from 'react-hook-form';

const EditMapForm = ({subEvent, event}: {subEvent?: SubEventType; event?: EventType}) => {
  const mapHost = subEvent ?? ({event} as SubEventType);
  const url = useWatch({name: 'url'});

  const [isEdit, setIsEdit] = React.useState<boolean>(false);

  return (
    <React.Fragment>
      <TextInput required fullWidth label="Name" name="name" />
      {!isEdit && (
        <React.Fragment>
          <Button onClick={() => setIsEdit(true)}>Edit Geo Map</Button>
          <ViewMap subEvent={mapHost} />
        </React.Fragment>
      )}
      {isEdit && <GeoReferenceMap imageSrcData={import.meta.env.VITE_UPLOADS + url} subEvent={mapHost} />}
    </React.Fragment>
  );
};

export default EditMapForm;
